/**
 * Utility functions for date formatting
 */

/**
 * Formats a date string or Date object to YYYY-mm-dd format
 * @param dateInput - Date string, Date object, or ISO string
 * @returns Formatted date string in YYYY-mm-dd format
 */
export const formatDateToYMD = (dateInput: string | Date): string => {
  try {
    const date = new Date(dateInput);
    
    // Check if the date is valid
    if (isNaN(date.getTime())) {
      console.warn('Invalid date provided to formatDateToYMD:', dateInput);
      return String(dateInput); // Return original input if invalid
    }
    
    return date.toISOString().split('T')[0];
  } catch (error) {
    console.error('Error formatting date:', error);
    return String(dateInput); // Return original input if error occurs
  }
};

/**
 * Formats a date for display in consistent YYYY-mm-dd format
 * This is a convenience function that wraps formatDateToYMD
 * @param dateInput - Date string, Date object, or ISO string
 * @returns Formatted date string in YYYY-mm-dd format
 */
export const formatDate = (dateInput: string | Date): string => {
  return formatDateToYMD(dateInput);
};